import "./Resumen.css"
import DescriptionDetail from "src/shared/components/data-display/description-detail/DescriptionDetail"
import TotalDetail from "./components/total-detail/TotalDetail"
import { Button } from "src/shared/components/forms"
import { useIVA } from "src/shared/hooks/useIVA"
import { useFormatDate } from "src/shared/hooks/useFormatDate"
import { times } from "src/shared/helpers/calculator"
import { TicketAbonar, TicketItemPayment } from "../Ticket"
import { capitalize } from "src/shared/helpers/capitalize"
import { LovePoint } from "src/pages/easyrewards/components/InputAbonarEasyRewards/InputAbonarEasyRewards.types"
import { TicketPaymentEdit } from "src/shared/sections/ticket/Ticket.sections"
import { ResumenResult } from "src/shared/hooks/useMotorTarifas/useMotorTarifas.type"
import LinkDescuento from "src/shared/sections/payment/descuentos/LinkDescuentos/LinkDescuento"

const Resumen = ({
    disabled,
    labels,
    costos,
    aux,
    onEditMixto,
    lovePointsAmount,
    reservaSaved,
    tarifas = [],
    tarifasPersonaExtra = [],
    descuento,
    onOpenDescuento,
    descuentoEditable = true,
    descuentoDisabled = false,
}: {
    disabled: boolean
    labels: {
        origen?: string
        codigo?: string
        fechasEstancia?: Date[]
        tipoHabitacion?: string
        personas?: number
        personasExtra?: number
        serviciosAdicionales?: string
        clientName?: string
        correo?: string
        telefono?: string
        experiencias?: { value: number; label: string }[]
    }
    aux: {
        numNoches?: number
    }
    costos: {
        estancia?: number
        personasExtra?: number
        experiencias?: number
        total?: number
    }
    lovePointsAmount: LovePoint | null
    onEditMixto: () => void
    descuento: {
        total: number
        nombre: string
    }
    onOpenDescuento: () => void
    descuentoEditable?: boolean
    descuentoDisabled?: boolean
    reservaSaved?: {
        reservaIdSaved?: string
        folioSaved?: number
        pagosTotalSaved?: number
        pagosSaved?: number
        totalSaved?: number
    }
    tarifas?: ResumenResult[]
    tarifasPersonaExtra?: ResumenResult[]
}) => {
    const { getIVA } = useIVA()
    const { formatCustomDate, nowHotel } = useFormatDate()

    const origen = () => {
        let label = "OTA"
        if (
            labels.origen === "recepcion" ||
            labels.origen === "telefono" ||
            labels.origen === "email" ||
            labels.origen === "otros"
        ) {
            label = ""
        }
        return label
    }

    const costoTotalEdit =
        reservaSaved?.pagosTotalSaved && costos.total ? costos.total - reservaSaved?.pagosTotalSaved : 0
    return (
        <div className="guest-resumen__wrapper">
            <div className="guest-resumen__header">
                <span className="guest-resumen__title">Resumen</span>
            </div>
            <div className="guest-resumen__body">
                {!!labels.codigo && (
                    <DescriptionDetail
                        darkMode
                        icon="bookMark"
                        label={"Código de reserva " + origen()}
                        value={`${capitalize(labels.origen || "")} - ${labels.codigo}`}
                        style={{ paddingBottom: "12px", paddingLeft: "12px", paddingRight: "12px" }}
                    />
                )}
                <DescriptionDetail
                    darkMode
                    icon="calendarFill"
                    label="Estancia"
                    value={`${formatCustomDate(labels.fechasEstancia?.[0] || nowHotel, "MMM DD, YYYY")} - ${formatCustomDate(
                        labels.fechasEstancia?.[1] || nowHotel, "MMM DD, YYYY"
                    )}`}
                    style={{ marginBottom: "12px", paddingLeft: "12px", paddingRight: "12px" }}
                />
                <DescriptionDetail
                    darkMode
                    icon="building4Fill"
                    label="Tipo de habitación"
                    value={labels.tipoHabitacion || ""}
                    style={{ marginBottom: "12px", paddingLeft: "12px", paddingRight: "12px" }}
                />
                <div className="guest-resumen__tarifa-description">
                    <DescriptionDetail
                        darkMode
                        icon="dollarCircle"
                        label="Estancia y tarifas"
                        value={tarifas.length === 0 ? ("-") : ""}
                        style={{ marginBottom: tarifas.length === 0 ? "12px" : "4px", paddingLeft: "12px", paddingRight: "12px" }}
                    />
                    {tarifas.map(({ nombre = "", items = [] }, index) => (
                        <div className="guest-resumen__tarifa-item" key={index}>
                            <p className="guest-resumen__tarifa-item-title">{nombre}</p>
                            {items.map(({ label = "", value }, i) => (
                                <div className="guest-resumen__tarifa-item-row" key={`${index}-${i}`}>
                                    <span className="guest-resumen__tarifa-item-label">{label}</span>
                                    <span className="guest-resumen__tarifa-item-value">{value}</span>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
                <DescriptionDetail
                    darkMode
                    icon="UserThinFilled"
                    label="Personas"
                    value={String(labels.personas || 0)}
                    style={{ marginBottom: "12px", paddingLeft: "12px", paddingRight: "12px" }}
                />
                {!!labels.personasExtra && (
                    <div className="guest-resumen__tarifa-description">
                        <DescriptionDetail
                            darkMode
                            icon="UserParentFill"
                            label="Personas extra"
                            value={tarifasPersonaExtra.length > 0 ? "" : String(labels.personasExtra || 0)}
                            style={{ marginBottom: tarifasPersonaExtra.length > 0 ? "4px" : "12px", paddingLeft: "12px", paddingRight: "12px" }}
                        />
                        {tarifasPersonaExtra
                            .filter(({ items = [] }) => items.some(({ value }) => value !== "$0"))
                            .map(({ nombre = "", items = [] }, index) => (
                                <div className="guest-resumen__tarifa-item" key={index}>
                                    <p className="guest-resumen__tarifa-item-title">{nombre}</p>
                                    {items.map(({ label = "", value }, i) => (
                                        <div className="guest-resumen__tarifa-item-row" key={`${index}-${i}`}>
                                            <span className="guest-resumen__tarifa-item-label">{label}</span>
                                            <span className="guest-resumen__tarifa-item-value">{value}</span>
                                        </div>
                                    ))}
                                </div>
                            ))}
                    </div>
                )}
                {!!labels.serviciosAdicionales && (
                    <DescriptionDetail
                        darkMode
                        icon="star"
                        label="Servicios adicionales"
                        value={String(labels.serviciosAdicionales || "")}
                        style={{ marginBottom: "12px", paddingLeft: "12px", paddingRight: "12px" }}
                    />
                )}
                {!!labels.clientName && !reservaSaved?.reservaIdSaved && (
                    <>
                        <div className="guest-resumen__divider"></div>
                        <DescriptionDetail
                            darkMode
                            icon="userFilled"
                            label="Nombre completo"
                            value={labels.clientName || ""}
                            style={{ padding: "12px" }}
                        />
                    </>
                )}
                {labels.telefono && !reservaSaved?.reservaIdSaved && (
                    <DescriptionDetail
                        darkMode
                        icon="phone"
                        label="Teléfono"
                        value={labels.telefono || ""}
                        style={{ marginBottom: "12px", paddingLeft: "12px", paddingRight: "12px" }}
                    />
                )}
                {labels.correo && !reservaSaved?.reservaIdSaved && (
                    <DescriptionDetail
                        darkMode
                        icon="mailOpenFill"
                        label="Correo"
                        value={labels.correo || ""}
                        style={{ marginBottom: "12px", paddingLeft: "12px", paddingRight: "12px" }}
                    />
                )}

                {reservaSaved?.reservaIdSaved && (
                    <>
                        <div className="guest-resumen__divider" style={{ marginBottom: "12px" }}></div>
                        <span className="guest-resumen__title-pagos-registrados" >
                            Pagos registrados
                        </span>
                        <div className="guest-resumen__pagos">
                            <TicketPaymentEdit pagos={reservaSaved?.pagosSaved} applyCustomFormat={true} />
                        </div>
                    </>
                )}

                <TicketItemPayment onClick={onEditMixto} experiencias={0} />
                <TicketAbonar lovePointsAmount={lovePointsAmount} />

                <div className="guest-resumen__divider"></div>
            </div>

            <div className="guest-resumen__footer">
                <TotalDetail
                    label={`Estancia (${aux.numNoches || 1} noche${(aux.numNoches || 1) > 1 ? "s" : ""})`}
                    value={costos.estancia || 0}
                />
                {!!labels.personasExtra && (
                    <TotalDetail
                        label={`Personas extra  (${aux.numNoches || 1} noche${(aux.numNoches || 1) > 1 ? "s" : ""})`}
                        value={tarifasPersonaExtra.length > 0
                            ? costos.personasExtra || 0
                            : times(costos.personasExtra || 0, aux.numNoches || 0)}
                    />
                )}
                {!!labels.experiencias && labels.experiencias.length > 0 && (
                    <>
                        <TotalDetail
                            label={`Experiencias (${labels.experiencias.length})`}
                            value={costos.experiencias || 0}
                        />
                    </>
                )}

                <TotalDetail label="Impuestos" value={getIVA(costos.total || 0)} type="thin" />
                <LinkDescuento
                    descuento={{ nombre: descuento.nombre || "Descuento", total: descuento.total }}
                    onOpenDescuento={onOpenDescuento}
                    editable={descuentoEditable}
                    disabled={descuentoDisabled}
                />
                {reservaSaved?.reservaIdSaved && reservaSaved && (
                    <>
                        <TotalDetail label={"Total de reserva"} value={costos.total || 0} type="normal" />
                        <TotalDetail
                            label={"Total pagado"}
                            value={reservaSaved.pagosTotalSaved || 0}
                            type="normal"
                            style={{ margin: "12px 0" }}
                            signo={true}
                        />
                    </>
                )}
                <TotalDetail
                    label={reservaSaved?.reservaIdSaved ? "Por Pagar" : "Total"}
                    value={reservaSaved?.reservaIdSaved ? costoTotalEdit : costos.total || 0}
                    type="total"
                    style={{ margin: "12px 0" }}
                />
                <div className="guest-resumen__action">
                    <div className="guest-resumen__divider"></div>
                    <div className="guest-resumen__action__button__container">
                        {reservaSaved?.reservaIdSaved ? (
                            <Button
                                text="Editar reserva"
                                className="guest-resumen__action__button"
                                type="submit"
                                disabled={disabled}
                            />
                        ) : (
                            <Button
                                text="Registrar reserva"
                                className="guest-resumen__action__button"
                                type="submit"
                                disabled={disabled}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Resumen
